<template>
    <div class="col-12" style="margin-top: 2.5em">
        <div class="content-container col-lg-6 center">
            <b-card>
                <b-card-body>
                    <div>
                        <span>{{ $t("payment.subscription_success")}}</span>
                        <!--  TODO: Show more details info of subscription, i.e. campaign and amount-->
                        <br>
                        <b-button
                                class="fair-button"
                                variant="success"
                                @click.stop="goToCampaignView"
                        >
                            {{ $t("payment.redirect")}}
                        </b-button>
                    </div>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>

<script>

    export default {
        name: "subscription-success-view",
        data() {
            return {
                timeout: null
            }
        },
        mounted() {
            if (this.$route.query.session_id) {
                this.transactionCompleted()
            } else {
                this.goToCampaignView()
            }
        },
        methods: {
            transactionCompleted: function () {
                this.timeout = setTimeout(this.goToCampaignView, 10000)
            },

            goToCampaignView: function () {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.$router.push({name: 'main-view'})
            }
        }
    }
</script>

